import { JSX, useEffect, useRef, useState } from "react"
import KanbanBoard from "../../../components/Kanban/Kanban";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { ButtonCard, toastError } from "../../../commons/utils";
import { Filtro } from "./Filtro";
import { ColaboradorInvalidacoes } from "../ColaboradorInvalidacoes";
import { ExCadastroPadrao } from "../../../components/ExCadastroPadrao";
import { model_colaborador } from "../../../models";
import ColaboradorPdf, { ColaboradorPdfHandler } from "../ColaboradorPdf";
import { confirmDesistencia, deleteFileColaborador, getFiles, updateStatus, uploadFileColaborador } from "../Colaborador/utils";
import { Gallery, GalleryHandler } from "../../Gallery";
import { ListX, Paperclip, Pencil, Printer, Redo, Undo, X } from "lucide-react";
import { Privilegio } from "../../../contexts/AuthProvider/types";

function createButton(hint: string, color: string, icon: JSX.Element, onClick: () => void, disabled?: boolean) {
    return (
        <ButtonCard hint={hint} color={color} iconcenter={icon} onClick={onClick} disabled={disabled} className='p-1 me-1' />
    );
}

export const ColaboradorKanban = () => {
    const auth = useAuth();

    const refKanbam = useRef<any>(null);
    const refCadastroPadrao = useRef<any>(null);
    const refFiltro = useRef<any>(null);
    const refinvalidacoes = useRef<any>(null);
    const refColaboradorPdf = useRef<ColaboradorPdfHandler>(null);
    const refgallery = useRef<GalleryHandler>(null);

    const [status, setStatus] = useState<any>();

    useEffect(() => {
        auth.get('/v1/colaboradorstatus')
            .then((response: any) => {
                const filteredData = response.data.filter((item: any) => item.colstatusativo === 1).sort((a: any, b: any) => a.colstatussequencia - b.colstatussequencia);

                const _status = filteredData.map((item: any) => ({
                    id: item.colstatusid,
                    title: item.colstatusdescricao,
                    color: item.colstatuscor,
                    value: item.colstatusid,
                    sequencia: item.colstatussequencia,
                    rejeitado: item.colstatusrejeicao
                }));

                _status.splice(-1, 0, {
                    id: 'desistente',
                    title: 'Desistente',
                    color: 'red',
                    value: 'desistente',
                    sequencia: _status[_status.length - 1].colstatussequencia - 0.5
                })

                setStatus(_status);
            })
            .catch((error: any) => {
                toastError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onGetData(data: any) {
        const newArray: any = [];
        refKanbam.current.setTasks([]);

        const sequencias = status.map((item: any) => item.sequencia);

        const menorSequencia = Math.min(...sequencias);
        const maiorSequencia = Math.max(...sequencias);

        data.forEach((item: any) => {

            const { colid, grudescricao, colnome, colcpf, colstatusid, colstatussequencia, colstatusrejeicao, coldesid } = item;

            const id = colid;
            const content =
                <div style={{ paddingTop: '5px' }}>
                    {colnome && <div style={{ paddingBottom: '5px' }}>{colnome}</div>}
                    {colcpf && <div style={{ fontSize: '12px', paddingBottom: '7px' }}>{colcpf}</div>}
                    {coldesid && <div style={{ fontSize: '12px', padding: '4px', borderRadius: '4px', color: 'white', backgroundColor: 'red', display: 'inline-block' }}>    Desistente    </div>}
                </div>
            const columnId = coldesid ? 'desistente' : colstatusid;
            const details = grudescricao;
            const color = status.find((_status: any) => _status.value === colstatusid)?.color;

            const functions = (
                coldesid ?
                    ((auth.privilegio ?? 0) >= Privilegio.Gestao ?
                        createButton('Confirmar Desistência', 'red', <X size={20} />, () => confirmDesistencia(auth, coldesid, colid).then(e => refFiltro.current.refresh())) :
                        <></>)
                    :
                    <>
                        {((auth.privilegio ?? 0) >= Privilegio.Gestao) && createButton('Invalidar', color, <ListX size={20} />, () => refinvalidacoes.current.openModal(item))}
                        {((auth.privilegio ?? 0) >= Privilegio.Gestao) && createButton('Editar', color, <Pencil size={20} />, () => refCadastroPadrao.current.openModal(item))}
                        {((auth.privilegio ?? 0) >= Privilegio.Gestao) && colstatusrejeicao !== 1 && (
                            <>
                                {colstatussequencia !== menorSequencia &&
                                    createButton('Retroceder Status', color, <Undo size={20} />, () => updateStatus(auth, status, item, false).then(e => refFiltro.current.refresh()))}

                                {colstatussequencia !== maiorSequencia &&
                                    createButton('Avançar Status', color, <Redo size={20} />, () => updateStatus(auth, status, item, true).then(e => refFiltro.current.refresh()))}
                            </>
                        )
                        }
                        {createButton('Arquivos', color, <Paperclip size={20} />,
                            async () => {
                                const files = await getFiles(auth, colid);
                                refgallery.current?.openModal(files, colnome, colid, true);
                            }
                        )}
                        {createButton('Imprimir', color, <Printer size={20} />, () => refColaboradorPdf.current?.generatePDF(colid))}
                    </>
            );

            const filterValues: string[] = [colnome, colcpf]

            newArray.push({ id, content, columnId, details, undefined, functions, filterValues });
        });

        refKanbam.current.setTasks(newArray);
    }

    function onSuccess() {
        refFiltro.current.refresh();
    }

    return (
        status &&
        <>
            <ColaboradorPdf ref={refColaboradorPdf} />
            <ExCadastroPadrao ref={refCadastroPadrao} model={model_colaborador} success={onSuccess} />
            <ColaboradorInvalidacoes ref={refinvalidacoes} onSuccess={onSuccess} />
            <KanbanBoard
                ref={refKanbam}
                columnsId={status?.map((item: any) => item.id)}
                status={status}
                filter={() => {
                    return <Filtro ref={refFiltro} onGetData={onGetData} />
                }}
            />
            <Gallery ref={refgallery} onUploadFile={(colid, file) => uploadFileColaborador(auth, colid, file)} onRemoveFile={(movid, file) => deleteFileColaborador(auth, movid, file)} />
        </>
    )
}